import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3302, { U3302ROLES } from './U3302';
import U3302CategoryList from './components/list/U3302CategoryList';
import U3302CategoryForm from './components/form/U3302CategoryForm';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3302Routes: RouteObject[] = [
  {
    path: 'U3302',
    element: <U2000RequireRole allowedRoles={[U3302ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3302 />,
        children: [
          { index: true, element: <U3302CategoryList /> },
          { path: ':id', element: <U3302CategoryForm /> },
        ],
      },
    ],
  },
];

export default U3302Routes;
